import React from 'react';

import { FormSpy } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';

/**
 * Интерфейс для свойств компонента WhenFieldChanges
 * @template T - Тип значений, которые могут быть в поле
 * @property {string} field - Имя поля, значение которого будет отслеживаться
 * @property {T[]} isIn - Массив значений, которые будут использоваться для сравнения
 * @property {string} reset - Имя поля, значение которого будет сбрасываться
 * @property {'in' | 'ex'} operation - Операция для проверки значения поля: 'in' для проверки наличия в массиве, 'ex' для проверки отсутствия в массиве
 */
interface WhenProps<T> {
  field: string;
  isIn: T[];
  reset: string;
  operation: 'in' | 'ex';
}

/**
 * Компонент для отслеживания изменений в поле формы и сброса значения другого поля при определенных условиях
 * @template T - Тип значений, которые могут быть в поле
 * @param {WhenProps<T>} props - Свойства компонента
 * @returns {React.ReactNode} - Компонент FormSpy с OnChange внутри
 */
export const WhenFieldChanges = <T extends unknown>({
  field,
  isIn,
  reset,
  operation,
}: WhenProps<T>) => (
  <FormSpy>
    {({ form }) => (
      <OnChange name={field}>
        {(value) => {
          const errors = form.getState().errors || {};
          const isIncludes = isIn.includes(value);

          if (
            (operation === 'in' ? isIncludes : !isIncludes) &&
            errors[reset]
          ) {
            form.change(reset, undefined);
            form.resetFieldState(reset);
          }
        }}
      </OnChange>
    )}
  </FormSpy>
);
